import React from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/common";
import { useSEO } from "@/lib/useSEO";
import { CONTACT } from "@/config/site";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </div>
);

export default function Privacy() {
  useSEO({ title: "Privacy Policy | Atmasamman Group", description: "How Atmasamman Group collects and uses enquiry information to respond to your requests.", path: "/privacy-policy" });
  return (
    <Layout>
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="Your privacy matters to us. This policy explains, in general terms, how we handle the information you share with us." />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Section title="Information We Collect">
            <p>When you submit an enquiry, we may collect information such as your name, email address, phone number, message and contact preference. This helps us understand and respond to your request.</p>
          </Section>
          <Section title="How We Use Your Information">
            <p>We use the information you provide solely to respond to your enquiry and to contact you using your selected contact preference. If you opt in, we may also share relevant updates from Atmasamman Group.</p>
          </Section>
          <Section title="Sharing of Information">
            <p>Your enquiry may be shared internally within the relevant Atmasamman Group organization (ATS, ASAI, AIMT or Atmasamman Foundation) so the right team can assist you. We do not sell your personal information.</p>
          </Section>
          <Section title="Data Security">
            <p>We take reasonable measures to protect the information you share with us. Enquiry details are stored securely and access is limited to authorised personnel.</p>
          </Section>
          <Section title="Your Choices">
            <p>You may request that we update or remove your enquiry information, or stop sending you updates, at any time by contacting us.</p>
          </Section>
          <Section title="Contact Us">
            <p>For any privacy-related questions, contact us at <a href={`mailto:${CONTACT.primaryEmail}`} className="font-medium text-orange-600 hover:underline">{CONTACT.primaryEmail}</a>.</p>
          </Section>
        </div>
      </section>
    </Layout>
  );
}
